// extracted by mini-css-extract-plugin
export default {"card":"foundCategoryCardsSet_card__LlT3D","supportive":"foundCategoryCardsSet_supportive__Q50fG"};